export type OneMapResponse = {
  found: number;
  pageNum: number;
  totalNumPages: number;
  results: OneMapResult[];
};

export type OneMapResult = {
  ADDRESS: string;
  BLK_NO: string;
  BUILDING: string;
  POSTAL: string;
  ROAD_NAME: string;
};

export type GenericAddress = {
  postalCode: string;
  blockNumber: string;
  streetName: string;
  buildingName: string;
};
